import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { Observable } from 'rxjs';
import { User } from '../../services/auth-api/models/index';
import { RoleEnum } from '../../services/auth-api/enums/role.enum';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class PermissionGuard {
  constructor(
    public router: Router,
    private toastrService: ToastrService,
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    // Guard for user is login or not
    let user: User | undefined = localStorage.getItem('user')
      ? JSON.parse(localStorage.getItem('user') ?? '')
      : null;

    let roleAdmin = RoleEnum[RoleEnum.Admin];
    let permission =
      'permission' in next.data
        ? (next.data['permission'] as string)
        : undefined;
    if (permission) {
      if (!user?.roles || !user?.permissions || user === null) {
        this.router.navigate(['/auth/login']);
        return false;
      } else if (
        !user.roles?.includes(roleAdmin) &&
        !user.permissions.includes(permission)
      ) {
        this.toastrService.error(
          `Se requiere permiso "${permission}" para acceder a esta página.`,
          '',
          {
            closeButton: true,
            enableHtml: true,
            positionClass: 'toast-bottom-right',
          },
        );
        this.router.navigate(['']);
        return false;
      }
    }
    return true;
  }
}
